module.exports = __webpack_public_path__ + "static/svobodova-e825b2716640a7ab77d126df7fabf3e9.jpg";